import $ from 'jquery'
import moment from 'moment'

export default {
	twoWay: true,
	params: ['dateFormat'],

	bind() {
		let self = this;
		$(this.el).daterangepicker({
			"locale": {
				"format": self.params.dateFormat
			},
			"singleDatePicker": true,
			"timePicker": true,
			"timePickerIncrement": 30
		});

	},

	update(value) {
		$(this.el).data('daterangepicker').setStartDate(value);
		$(this.el).data('daterangepicker').setEndDate(value);
	},

	unbind() {
	}
}



// WEBPACK FOOTER //
// ./src/directives/daterangepicker.js